import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

interface Container {
  containerId: number;
  containerName: string;
  qty: number;
  totalCost: number;
  unitCost: number;
}

interface ProductContainerRow {
  productId: number;
  productCode: string;
  productName: string;
  totalQty: number;
  totalCost: number;
  unitCost: number;
  containers: Container[];
}

interface TableColumn {
  key: string;
  label: string;
  align?: string;
  bold?: boolean;
}

@Component({
  selector: 'app-existences-by-place-maye-preview',
  templateUrl: './existences-by-place-maye-preview.component.html',
  styleUrls: ['./existences-by-place-maye-preview.component.scss']
})
export class ExistencesByPlaceMayePreviewComponent implements OnChanges {
  @Input() data: any = null;

  containers: string[] = [];
  columns: TableColumn[] = [];

  // 🔹 Se ejecuta cada vez que cambia el Input
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && this.data?.length) {
      this.buildColumns();
    }
  }

  // 🔹 Construcción dinámica de columnas
  private buildColumns(): void {
    this.containers = this.data
      .flatMap(p => p.containers)
      .map(c => c.containerName)
      .filter((v, i, a) => a.indexOf(v) === i);

    this.columns = [
      { key: 'product', label: 'PRODUCTO', align: 'start', bold: true },
      ...this.containers.map(c => ({
        key: c,
        label: c,
        align: 'end'
      })),
      { key: 'total', label: 'TOTAL', align: 'end', bold: true }
    ];
  }

  // 🔹 Cantidad por contenedor
  getQty(row: ProductContainerRow, containerName: string): number {
    return row.containers.find(c => c.containerName === containerName)?.qty ?? 0;
  }

  // 🔹 Totales por columna
  getTotalByContainer(containerName: string): number {
    return this.data.reduce(
      (sum, p) => sum + (p.containers.find(c => c.containerName === containerName)?.qty || 0),
      0
    );
  }

  // 🔹 Total general
  getGrandTotal(): number {
    return this.data.reduce((sum, p) => sum + p.totalQty, 0);
  }
}
